
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"12","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 1.5l-6.71 6L1 4.559","stroke":"#EE2300","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
      }
    
      }
    